<template>
  <div class="g-content g-filter">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('role_btn_auth_data') }}
          <span v-if="roleInfo" style="color:#1838d9"> ({{ roleInfo.name }}) </span>
        </h3>

        <div class="g-content-filter-right">
          <a-button
            type="default"
            @click="
              () => {
                this.$router.go(-1);
              }
            "
            icon="double-left"
          >
            {{ $t('com_btn_back') }}
          </a-button>
          <a-button type="primary" @click.prevent="authSubmit" :loading="loading">
            {{ $t('com_btn_save') }}
          </a-button>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="form" v-if="roleId && roleInfo">
        <a-form-model
          :model="form"
          :rules="formRules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
          ref="formElement"
        >
          <!-- 客户访问权限 -->
          <a-form-model-item :label="$t('role_form_access_customer')" prop="customerRangeLevel">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.customerRangeLevel"
              show-search
              :placeholder="$t('com_form_select_placeholder')"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <!-- 	integer($int32) 客户访问范围控制：0表示所有所属客户；1表示当前用户所属客户；2：指定客户列表 -->
              <a-select-option
                :value="item.value"
                v-for="item in $t('role_auth').customer"
                :key="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 站点访问权限 -->
          <a-form-model-item :label="$t('role_form_access_site')" prop="stationRangeLevel">
            <!-- 站点访问范围控制；0表示所有所属站点；1表示指定站点列表 -->
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.stationRangeLevel"
              show-search
              :placeholder="$t('com_form_select_placeholder')"
              :disabled="stationMustBeAll"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option
                :value="item.value"
                v-for="item in $t('role_auth').site"
                :key="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 是否接收邮件告警 -->
          <a-form-model-item :label="$t('role_form_email')" prop="receiveAlarmEmail">
            <!-- 
          是否可接受告警邮件，0-不允许，1-仅允许
         -->
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.receiveAlarmEmail"
              show-search
              :placeholder="$t('com_form_select_placeholder')"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option :value="1">Yes</a-select-option>
              <a-select-option :value="0">No</a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- web/ssh访问控制 -->
          <a-form-model-item
            :label="$t('role_form_webui_ssh')"
            prop="webSshAccess"
            style="margin-bottom:0"
          >
            <!-- 
          0-不允许WEB和SSH，1-仅允许web/ssh root权限，2-仅允许web admin权限，3-仅允许web engineer权限
         -->
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.webSshAccess"
              show-search
              :placeholder="$t('com_form_select_placeholder')"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option
                :value="item.value"
                v-for="item in $t('role_auth').webAccess"
                :key="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label=" " style="margin-bottom:0" :colon="false">
            <div class="role-form-tip">
              {{ $t('role_form_webui_ssh_tip1') }}:<br />
              {{ $t('role_form_webui_ssh_tip2') }}
            </div>
          </a-form-model-item>

          <!-- 用户操作权限 -->
          <a-form-model-item
            :label="$t('role_form_access_user')"
            prop="userRangeLevel"
            style="margin-bottom:0;"
          >
            <!-- 用户数据访问范围控制，0-最高级别控制，1~5，5个不同级别控制，数字越大权限越弱 -->
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.userRangeLevel"
              style="width:50px"
              :placeholder="$t('com_form_select_placeholder')"
            >
              <a-select-option
                :value="item"
                v-for="item in $t('role_auth').levelNumber"
                :key="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 设备配置访问权限级别 -->
          <a-form-model-item :label="$t('role_form_access_device')" style="margin-bottom:0;">
            <div>
              <!-- <p>0-最高级别控制，1~5，5个不同级别控制，数字越大权限越</p> -->
              <a-row>
                <a-col :span="10">
                  <a-form-model-item
                    :label="$t('role_form_read')"
                    prop="cfgReadLevel"
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 18 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.cfgReadLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12"> </a-col>
              </a-row>
            </div>
          </a-form-model-item>

          <!-- 设备参数访问权限级别 -->
          <a-form-model-item :label="$t('role_form_access_params')" style="margin-bottom:0">
            <div>
              <!-- <p>0-最高级别控制，1~5，5个不同级别控制，数字越大权限越</p> -->
              <a-row>
                <a-col :span="10">
                  <a-form-model-item
                    :label="$t('role_form_read')"
                    prop="paramReadLevel"
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 18 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.paramReadLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('role_form_write')"
                    prop="paramWriteLevel"
                    :labelCol="{ span: 4 }"
                    :wrapperCol="{ span: 20 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.paramWriteLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model-item>

          <!-- 文档访问权限 -->
          <a-form-model-item :label="$t('role_form_access_wiki')" style="margin-bottom:0">
            <div>
              <!-- <p>0-最高级别控制，1~5，5个不同级别控制，数字越大权限越</p> -->
              <a-row>
                <a-col :span="10">
                  <a-form-model-item
                    :label="$t('role_form_read')"
                    prop="wikiReadLevel"
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 18 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.wikiReadLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('role_form_write')"
                    prop="wikiWriteLevel"
                    :labelCol="{ span: 4 }"
                    :wrapperCol="{ span: 20 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.wikiWriteLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model-item>

          <!-- 附件访问权限 -->
          <a-form-model-item :label="$t('role_form_access_attach')" style="margin-bottom:0">
            <div>
              <!-- <p>0-最高级别控制，1~5，5个不同级别控制，数字越大权限越</p> -->
              <a-row>
                <a-col :span="10">
                  <a-form-model-item
                    :label="$t('role_form_read')"
                    prop="attachReadLevel"
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 18 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.attachReadLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('role_form_write')"
                    prop="attachWriteLevel"
                    :labelCol="{ span: 4 }"
                    :wrapperCol="{ span: 20 }"
                  >
                    <a-select
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      v-model="form.attachWriteLevel"
                      style="width:50px"
                      :placeholder="$t('com_form_select_placeholder')"
                    >
                      <a-select-option
                        :value="item"
                        v-for="item in $t('role_auth').levelNumber"
                        :key="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model-item>

          <div style="text-align: center; width: 100%; color: red; line-height: 20px;height:20px;">
            {{ formError }}
          </div>
        </a-form-model>
      </div>
      <Empty v-else />
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/role';
import Config from '@/config';

export default {
  components: {},

  watch: {
    form: {
      handler(form) {
        console.log(form);
        if (form.customerRangeLevel === 0) {
          this.form.stationRangeLevel = 0;
          this.stationMustBeAll = true;
        } else {
          this.stationMustBeAll = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      Config,
      roleId: null,
      roleInfo: null,
      roleDataAuth: null,
      stationMustBeAll: false,

      form: {
        // 客户访问权限
        customerRangeLevel: undefined,

        // 站点访问权限
        stationRangeLevel: undefined,

        // 是否接收邮件告警
        receiveAlarmEmail: undefined,

        // 用户操作权限
        userRangeLevel: undefined,

        // web/ssh权限
        webSshAccess: undefined,

        // 设备配置访问权限级别
        cfgReadLevel: undefined,

        // 设备参数访问权限级别：读
        paramReadLevel: undefined,
        // 设备参数访问权限级别：写
        paramWriteLevel: undefined,

        // 文档访问权限级别：读
        wikiReadLevel: undefined,
        // 文档访问权限级别：写
        wikiWriteLevel: undefined,

        // 附件访问权限级别：读
        attachReadLevel: undefined,
        // 附件访问权限级别：写
        attachWriteLevel: undefined,
      },

      formRules: {
        customerRangeLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        stationRangeLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        receiveAlarmEmail: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        webSshAccess: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        userRangeLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        cfgReadLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        paramReadLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
        paramWriteLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],

        wikiReadLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],

        wikiWriteLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],

        attachReadLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],

        attachWriteLevel: [
          {
            required: true,
            message: this.$t('com_form_select_placeholder'),
          },
        ],
      },
      formError: '',
      loading: false,
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.RoeId) {
      this.roleId = this.$route.params.RoeId;
    }
    this.getRoleDetail();
  },
  methods: {
    // 获取角色详情
    getRoleDetail() {
      API.RoleDetail({ id: this.roleId })
        .then(res => {
          if (res.code === 0) {
            this.roleInfo = res.data;
            this.roleDataAuth = res.data.dataAuth;
            this.form = { ...this.roleDataAuth };
          }
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 提交
    authSubmit() {
      this.loading = true;
      const params = {
        id: this.roleInfo.id,
        ...this.form,
      };
      API.RoleDataAuth(params)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('com_msg_data_auth_success'));
          } else {
            this.formError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  max-width: 1000px;
}
.role-form-tip {
  padding: 5px 10px;
  background: #f9f9f9;
  line-height: 20px;
  font-size: 12px;
  margin-bottom: 5px;
  margin-top: 10px;
  border-radius: 5px;
}
</style>
